export type Type = {
	id: string;
	name: string;
	source: string | null;
	weight: number;
};

export function create(): Type {
	return {
		id: '',
		name: '',
		source: null,
		weight: 0,
	};
}

export function getTitle(obj: Type): string | undefined {
	if (obj.source) return obj.source;
	return undefined;
}
